export enum CardType {
    Horizontal = "horizontal-card",
    Stacked = "stacked-card"
}